import React, { FC } from "react";

export const AiConfirmDialog: FC = () => {
  return (
    <div>
      <p>
        By confirming, the AI will search official university websites to gather
        information about your university's programs and automatically create
        them on the platform. All newly created programs will remain{" "}
        <strong>disabled by default</strong>, allowing you to review and make
        any necessary changes before enabling them.
      </p>
      <p>
        This process may take some time, up to an hour, but you do not need to
        wait. The process will continue automatically, even if you close your
        browser.
      </p>
      <p>Would you like to proceed?</p>
    </div>
  );
};
